import { DataService } from '../../data.service';
import { HttpClient } from '@angular/common/http';
import { Localitat } from '../model/localitat';
import { Injectable } from '@angular/core';

@Injectable()
export class BLLocalitat {

    constructor(
        private dataService: DataService,
        private http: HttpClient) {
    }

    list(): Promise<Localitat[]> {
        return new Promise<Localitat[]>((resolve, reject) => {
            this.http.get<Localitat[]>(this.dataService.getApiEndpoint('localitat')).subscribe(data => {
                resolve(data);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/lib/bl/bllocalitat.ts